import { isPhoneNumberValid } from '@pb/apps/offers/services/phone-number';
import { emptyFieldError } from './generic-validator';

export async function validatePhoneNumber(value: string) {
    if (!value) {
        return emptyFieldError;
    }

    const isValid = await isPhoneNumberValid(value);

    return isValid ? '' : 'A valid contact number needs to be entered';
}
